/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SelfRegisterRouteImport } from './routes/self-register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as LoginIndexRouteImport } from './routes/login.index'
import { Route as LoginNewPasswordRouteImport } from './routes/login.new-password'
import { Route as LoginMfaTotpSetupRouteImport } from './routes/login.mfa-totp-setup'
import { Route as LoginMfaSetupRouteImport } from './routes/login.mfa-setup'
import { Route as LoginMfaEmailSetupRouteImport } from './routes/login.mfa-email-setup'
import { Route as LoginMfaChallengeRouteImport } from './routes/login.mfa-challenge'
import { Route as AuthenticatedLayoutRouteImport } from './routes/_authenticated/_layout'
import { Route as AuthenticatedLayoutIndexRouteImport } from './routes/_authenticated/_layout.index'
import { Route as AuthenticatedLayoutPlatformRouteImport } from './routes/_authenticated/_layout.platform'
import { Route as AuthenticatedLayoutTenantSecurityRouteImport } from './routes/_authenticated/_layout.tenant.security'
import { Route as AuthenticatedLayoutTenantGroupsRouteImport } from './routes/_authenticated/_layout.tenant.groups'
import { Route as AuthenticatedLayoutTenantBrandingRouteImport } from './routes/_authenticated/_layout.tenant.branding'
import { Route as AuthenticatedLayoutTenantAuditRouteImport } from './routes/_authenticated/_layout.tenant.audit'
import { Route as AuthenticatedLayoutPlatformTenantTypesRouteImport } from './routes/_authenticated/_layout.platform.tenant-types'
import { Route as AuthenticatedLayoutPlatformSecurityRouteImport } from './routes/_authenticated/_layout.platform.security'
import { Route as AuthenticatedLayoutPlatformRolesRouteImport } from './routes/_authenticated/_layout.platform.roles'
import { Route as AuthenticatedLayoutPlatformBrandingRouteImport } from './routes/_authenticated/_layout.platform.branding'
import { Route as AuthenticatedLayoutPlatformAuditRouteImport } from './routes/_authenticated/_layout.platform.audit'
import { Route as AuthenticatedLayoutPlatformAdminsRouteImport } from './routes/_authenticated/_layout.platform.admins'
import { Route as AuthenticatedLayoutMeProfileRouteImport } from './routes/_authenticated/_layout.me.profile'
import { Route as AuthenticatedLayoutTenantUsersIndexRouteImport } from './routes/_authenticated/_layout.tenant.users.index'
import { Route as AuthenticatedLayoutTenantRolesIndexRouteImport } from './routes/_authenticated/_layout.tenant.roles.index'
import { Route as AuthenticatedLayoutPlatformTenantsIndexRouteImport } from './routes/_authenticated/_layout.platform.tenants.index'
import { Route as AuthenticatedLayoutPlatformApplicationsIndexRouteImport } from './routes/_authenticated/_layout.platform.applications.index'
import { Route as AuthenticatedLayoutMeSecurityIndexRouteImport } from './routes/_authenticated/_layout.me.security.index'
import { Route as AuthenticatedLayoutTenantUsersNewRouteImport } from './routes/_authenticated/_layout.tenant.users.new'
import { Route as AuthenticatedLayoutTenantRolesRoleIdRouteImport } from './routes/_authenticated/_layout.tenant.roles.$roleId'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId'
import { Route as AuthenticatedLayoutPlatformApplicationsApplicationIdRouteImport } from './routes/_authenticated/_layout.platform.applications.$applicationId'
import { Route as AuthenticatedLayoutMeSecurityMfaTotpSetupRouteImport } from './routes/_authenticated/_layout.me.security.mfa-totp-setup'
import { Route as AuthenticatedLayoutMeSecurityMfaSmsSetupRouteImport } from './routes/_authenticated/_layout.me.security.mfa-sms-setup'
import { Route as AuthenticatedLayoutMeSecurityMfaSetupRouteImport } from './routes/_authenticated/_layout.me.security.mfa-setup'
import { Route as AuthenticatedLayoutMeSecurityMfaPreferenceRouteImport } from './routes/_authenticated/_layout.me.security.mfa-preference'
import { Route as AuthenticatedLayoutMeSecurityMfaEmailSetupRouteImport } from './routes/_authenticated/_layout.me.security.mfa-email-setup'
import { Route as AuthenticatedLayoutMeSecurityChangePasswordRouteImport } from './routes/_authenticated/_layout.me.security.change-password'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdIndexRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId.index'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdUsersRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId.users'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId.user-fields'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdRolesRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId.roles'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdIntegrationsRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId.integrations'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdBrandingRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId.branding'
import { Route as AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRouteImport } from './routes/_authenticated/_layout.platform.tenants.$tenantId.levels.$level'

const SelfRegisterRoute = SelfRegisterRouteImport.update({
  id: '/self-register',
  path: '/self-register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoginRoute,
} as any)
const LoginNewPasswordRoute = LoginNewPasswordRouteImport.update({
  id: '/new-password',
  path: '/new-password',
  getParentRoute: () => LoginRoute,
} as any)
const LoginMfaTotpSetupRoute = LoginMfaTotpSetupRouteImport.update({
  id: '/mfa-totp-setup',
  path: '/mfa-totp-setup',
  getParentRoute: () => LoginRoute,
} as any)
const LoginMfaSetupRoute = LoginMfaSetupRouteImport.update({
  id: '/mfa-setup',
  path: '/mfa-setup',
  getParentRoute: () => LoginRoute,
} as any)
const LoginMfaEmailSetupRoute = LoginMfaEmailSetupRouteImport.update({
  id: '/mfa-email-setup',
  path: '/mfa-email-setup',
  getParentRoute: () => LoginRoute,
} as any)
const LoginMfaChallengeRoute = LoginMfaChallengeRouteImport.update({
  id: '/mfa-challenge',
  path: '/mfa-challenge',
  getParentRoute: () => LoginRoute,
} as any)
const AuthenticatedLayoutRoute = AuthenticatedLayoutRouteImport.update({
  id: '/_authenticated/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedLayoutIndexRoute =
  AuthenticatedLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutPlatformRoute =
  AuthenticatedLayoutPlatformRouteImport.update({
    id: '/platform',
    path: '/platform',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantSecurityRoute =
  AuthenticatedLayoutTenantSecurityRouteImport.update({
    id: '/tenant/security',
    path: '/tenant/security',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantGroupsRoute =
  AuthenticatedLayoutTenantGroupsRouteImport.update({
    id: '/tenant/groups',
    path: '/tenant/groups',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantBrandingRoute =
  AuthenticatedLayoutTenantBrandingRouteImport.update({
    id: '/tenant/branding',
    path: '/tenant/branding',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantAuditRoute =
  AuthenticatedLayoutTenantAuditRouteImport.update({
    id: '/tenant/audit',
    path: '/tenant/audit',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantTypesRoute =
  AuthenticatedLayoutPlatformTenantTypesRouteImport.update({
    id: '/tenant-types',
    path: '/tenant-types',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutPlatformSecurityRoute =
  AuthenticatedLayoutPlatformSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutPlatformRolesRoute =
  AuthenticatedLayoutPlatformRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutPlatformBrandingRoute =
  AuthenticatedLayoutPlatformBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutPlatformAuditRoute =
  AuthenticatedLayoutPlatformAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutPlatformAdminsRoute =
  AuthenticatedLayoutPlatformAdminsRouteImport.update({
    id: '/admins',
    path: '/admins',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutMeProfileRoute =
  AuthenticatedLayoutMeProfileRouteImport.update({
    id: '/me/profile',
    path: '/me/profile',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantUsersIndexRoute =
  AuthenticatedLayoutTenantUsersIndexRouteImport.update({
    id: '/tenant/users/',
    path: '/tenant/users/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantRolesIndexRoute =
  AuthenticatedLayoutTenantRolesIndexRouteImport.update({
    id: '/tenant/roles/',
    path: '/tenant/roles/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsIndexRoute =
  AuthenticatedLayoutPlatformTenantsIndexRouteImport.update({
    id: '/tenants/',
    path: '/tenants/',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutPlatformApplicationsIndexRoute =
  AuthenticatedLayoutPlatformApplicationsIndexRouteImport.update({
    id: '/applications/',
    path: '/applications/',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutMeSecurityIndexRoute =
  AuthenticatedLayoutMeSecurityIndexRouteImport.update({
    id: '/me/security/',
    path: '/me/security/',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantUsersNewRoute =
  AuthenticatedLayoutTenantUsersNewRouteImport.update({
    id: '/tenant/users/new',
    path: '/tenant/users/new',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutTenantRolesRoleIdRoute =
  AuthenticatedLayoutTenantRolesRoleIdRouteImport.update({
    id: '/tenant/roles/$roleId',
    path: '/tenant/roles/$roleId',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdRouteImport.update({
    id: '/tenants/$tenantId',
    path: '/tenants/$tenantId',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutPlatformApplicationsApplicationIdRoute =
  AuthenticatedLayoutPlatformApplicationsApplicationIdRouteImport.update({
    id: '/applications/$applicationId',
    path: '/applications/$applicationId',
    getParentRoute: () => AuthenticatedLayoutPlatformRoute,
  } as any)
const AuthenticatedLayoutMeSecurityMfaTotpSetupRoute =
  AuthenticatedLayoutMeSecurityMfaTotpSetupRouteImport.update({
    id: '/me/security/mfa-totp-setup',
    path: '/me/security/mfa-totp-setup',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMeSecurityMfaSmsSetupRoute =
  AuthenticatedLayoutMeSecurityMfaSmsSetupRouteImport.update({
    id: '/me/security/mfa-sms-setup',
    path: '/me/security/mfa-sms-setup',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMeSecurityMfaSetupRoute =
  AuthenticatedLayoutMeSecurityMfaSetupRouteImport.update({
    id: '/me/security/mfa-setup',
    path: '/me/security/mfa-setup',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMeSecurityMfaPreferenceRoute =
  AuthenticatedLayoutMeSecurityMfaPreferenceRouteImport.update({
    id: '/me/security/mfa-preference',
    path: '/me/security/mfa-preference',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMeSecurityMfaEmailSetupRoute =
  AuthenticatedLayoutMeSecurityMfaEmailSetupRouteImport.update({
    id: '/me/security/mfa-email-setup',
    path: '/me/security/mfa-email-setup',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutMeSecurityChangePasswordRoute =
  AuthenticatedLayoutMeSecurityChangePasswordRouteImport.update({
    id: '/me/security/change-password',
    path: '/me/security/change-password',
    getParentRoute: () => AuthenticatedLayoutRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLayoutPlatformTenantsTenantIdRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedLayoutPlatformTenantsTenantIdRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRouteImport.update({
    id: '/user-fields',
    path: '/user-fields',
    getParentRoute: () => AuthenticatedLayoutPlatformTenantsTenantIdRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthenticatedLayoutPlatformTenantsTenantIdRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdIntegrationsRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedLayoutPlatformTenantsTenantIdRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => AuthenticatedLayoutPlatformTenantsTenantIdRoute,
  } as any)
const AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute =
  AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRouteImport.update({
    id: '/levels/$level',
    path: '/levels/$level',
    getParentRoute: () => AuthenticatedLayoutPlatformTenantsTenantIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/activate': typeof ActivateRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRouteWithChildren
  '/self-register': typeof SelfRegisterRoute
  '/': typeof AuthenticatedLayoutIndexRoute
  '/login/mfa-challenge': typeof LoginMfaChallengeRoute
  '/login/mfa-email-setup': typeof LoginMfaEmailSetupRoute
  '/login/mfa-setup': typeof LoginMfaSetupRoute
  '/login/mfa-totp-setup': typeof LoginMfaTotpSetupRoute
  '/login/new-password': typeof LoginNewPasswordRoute
  '/login/': typeof LoginIndexRoute
  '/platform': typeof AuthenticatedLayoutPlatformRouteWithChildren
  '/me/profile': typeof AuthenticatedLayoutMeProfileRoute
  '/platform/admins': typeof AuthenticatedLayoutPlatformAdminsRoute
  '/platform/audit': typeof AuthenticatedLayoutPlatformAuditRoute
  '/platform/branding': typeof AuthenticatedLayoutPlatformBrandingRoute
  '/platform/roles': typeof AuthenticatedLayoutPlatformRolesRoute
  '/platform/security': typeof AuthenticatedLayoutPlatformSecurityRoute
  '/platform/tenant-types': typeof AuthenticatedLayoutPlatformTenantTypesRoute
  '/tenant/audit': typeof AuthenticatedLayoutTenantAuditRoute
  '/tenant/branding': typeof AuthenticatedLayoutTenantBrandingRoute
  '/tenant/groups': typeof AuthenticatedLayoutTenantGroupsRoute
  '/tenant/security': typeof AuthenticatedLayoutTenantSecurityRoute
  '/me/security/change-password': typeof AuthenticatedLayoutMeSecurityChangePasswordRoute
  '/me/security/mfa-email-setup': typeof AuthenticatedLayoutMeSecurityMfaEmailSetupRoute
  '/me/security/mfa-preference': typeof AuthenticatedLayoutMeSecurityMfaPreferenceRoute
  '/me/security/mfa-setup': typeof AuthenticatedLayoutMeSecurityMfaSetupRoute
  '/me/security/mfa-sms-setup': typeof AuthenticatedLayoutMeSecurityMfaSmsSetupRoute
  '/me/security/mfa-totp-setup': typeof AuthenticatedLayoutMeSecurityMfaTotpSetupRoute
  '/platform/applications/$applicationId': typeof AuthenticatedLayoutPlatformApplicationsApplicationIdRoute
  '/platform/tenants/$tenantId': typeof AuthenticatedLayoutPlatformTenantsTenantIdRouteWithChildren
  '/tenant/roles/$roleId': typeof AuthenticatedLayoutTenantRolesRoleIdRoute
  '/tenant/users/new': typeof AuthenticatedLayoutTenantUsersNewRoute
  '/me/security/': typeof AuthenticatedLayoutMeSecurityIndexRoute
  '/platform/applications/': typeof AuthenticatedLayoutPlatformApplicationsIndexRoute
  '/platform/tenants/': typeof AuthenticatedLayoutPlatformTenantsIndexRoute
  '/tenant/roles/': typeof AuthenticatedLayoutTenantRolesIndexRoute
  '/tenant/users/': typeof AuthenticatedLayoutTenantUsersIndexRoute
  '/platform/tenants/$tenantId/branding': typeof AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute
  '/platform/tenants/$tenantId/integrations': typeof AuthenticatedLayoutPlatformTenantsTenantIdIntegrationsRoute
  '/platform/tenants/$tenantId/roles': typeof AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute
  '/platform/tenants/$tenantId/user-fields': typeof AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute
  '/platform/tenants/$tenantId/users': typeof AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute
  '/platform/tenants/$tenantId/': typeof AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute
  '/platform/tenants/$tenantId/levels/$level': typeof AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute
}
export interface FileRoutesByTo {
  '/activate': typeof ActivateRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/self-register': typeof SelfRegisterRoute
  '/login/mfa-challenge': typeof LoginMfaChallengeRoute
  '/login/mfa-email-setup': typeof LoginMfaEmailSetupRoute
  '/login/mfa-setup': typeof LoginMfaSetupRoute
  '/login/mfa-totp-setup': typeof LoginMfaTotpSetupRoute
  '/login/new-password': typeof LoginNewPasswordRoute
  '/login': typeof LoginIndexRoute
  '/platform': typeof AuthenticatedLayoutPlatformRouteWithChildren
  '/': typeof AuthenticatedLayoutIndexRoute
  '/me/profile': typeof AuthenticatedLayoutMeProfileRoute
  '/platform/admins': typeof AuthenticatedLayoutPlatformAdminsRoute
  '/platform/audit': typeof AuthenticatedLayoutPlatformAuditRoute
  '/platform/branding': typeof AuthenticatedLayoutPlatformBrandingRoute
  '/platform/roles': typeof AuthenticatedLayoutPlatformRolesRoute
  '/platform/security': typeof AuthenticatedLayoutPlatformSecurityRoute
  '/platform/tenant-types': typeof AuthenticatedLayoutPlatformTenantTypesRoute
  '/tenant/audit': typeof AuthenticatedLayoutTenantAuditRoute
  '/tenant/branding': typeof AuthenticatedLayoutTenantBrandingRoute
  '/tenant/groups': typeof AuthenticatedLayoutTenantGroupsRoute
  '/tenant/security': typeof AuthenticatedLayoutTenantSecurityRoute
  '/me/security/change-password': typeof AuthenticatedLayoutMeSecurityChangePasswordRoute
  '/me/security/mfa-email-setup': typeof AuthenticatedLayoutMeSecurityMfaEmailSetupRoute
  '/me/security/mfa-preference': typeof AuthenticatedLayoutMeSecurityMfaPreferenceRoute
  '/me/security/mfa-setup': typeof AuthenticatedLayoutMeSecurityMfaSetupRoute
  '/me/security/mfa-sms-setup': typeof AuthenticatedLayoutMeSecurityMfaSmsSetupRoute
  '/me/security/mfa-totp-setup': typeof AuthenticatedLayoutMeSecurityMfaTotpSetupRoute
  '/platform/applications/$applicationId': typeof AuthenticatedLayoutPlatformApplicationsApplicationIdRoute
  '/tenant/roles/$roleId': typeof AuthenticatedLayoutTenantRolesRoleIdRoute
  '/tenant/users/new': typeof AuthenticatedLayoutTenantUsersNewRoute
  '/me/security': typeof AuthenticatedLayoutMeSecurityIndexRoute
  '/platform/applications': typeof AuthenticatedLayoutPlatformApplicationsIndexRoute
  '/platform/tenants': typeof AuthenticatedLayoutPlatformTenantsIndexRoute
  '/tenant/roles': typeof AuthenticatedLayoutTenantRolesIndexRoute
  '/tenant/users': typeof AuthenticatedLayoutTenantUsersIndexRoute
  '/platform/tenants/$tenantId/branding': typeof AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute
  '/platform/tenants/$tenantId/integrations': typeof AuthenticatedLayoutPlatformTenantsTenantIdIntegrationsRoute
  '/platform/tenants/$tenantId/roles': typeof AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute
  '/platform/tenants/$tenantId/user-fields': typeof AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute
  '/platform/tenants/$tenantId/users': typeof AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute
  '/platform/tenants/$tenantId': typeof AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute
  '/platform/tenants/$tenantId/levels/$level': typeof AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/activate': typeof ActivateRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRouteWithChildren
  '/self-register': typeof SelfRegisterRoute
  '/_authenticated/_layout': typeof AuthenticatedLayoutRouteWithChildren
  '/login/mfa-challenge': typeof LoginMfaChallengeRoute
  '/login/mfa-email-setup': typeof LoginMfaEmailSetupRoute
  '/login/mfa-setup': typeof LoginMfaSetupRoute
  '/login/mfa-totp-setup': typeof LoginMfaTotpSetupRoute
  '/login/new-password': typeof LoginNewPasswordRoute
  '/login/': typeof LoginIndexRoute
  '/_authenticated/_layout/platform': typeof AuthenticatedLayoutPlatformRouteWithChildren
  '/_authenticated/_layout/': typeof AuthenticatedLayoutIndexRoute
  '/_authenticated/_layout/me/profile': typeof AuthenticatedLayoutMeProfileRoute
  '/_authenticated/_layout/platform/admins': typeof AuthenticatedLayoutPlatformAdminsRoute
  '/_authenticated/_layout/platform/audit': typeof AuthenticatedLayoutPlatformAuditRoute
  '/_authenticated/_layout/platform/branding': typeof AuthenticatedLayoutPlatformBrandingRoute
  '/_authenticated/_layout/platform/roles': typeof AuthenticatedLayoutPlatformRolesRoute
  '/_authenticated/_layout/platform/security': typeof AuthenticatedLayoutPlatformSecurityRoute
  '/_authenticated/_layout/platform/tenant-types': typeof AuthenticatedLayoutPlatformTenantTypesRoute
  '/_authenticated/_layout/tenant/audit': typeof AuthenticatedLayoutTenantAuditRoute
  '/_authenticated/_layout/tenant/branding': typeof AuthenticatedLayoutTenantBrandingRoute
  '/_authenticated/_layout/tenant/groups': typeof AuthenticatedLayoutTenantGroupsRoute
  '/_authenticated/_layout/tenant/security': typeof AuthenticatedLayoutTenantSecurityRoute
  '/_authenticated/_layout/me/security/change-password': typeof AuthenticatedLayoutMeSecurityChangePasswordRoute
  '/_authenticated/_layout/me/security/mfa-email-setup': typeof AuthenticatedLayoutMeSecurityMfaEmailSetupRoute
  '/_authenticated/_layout/me/security/mfa-preference': typeof AuthenticatedLayoutMeSecurityMfaPreferenceRoute
  '/_authenticated/_layout/me/security/mfa-setup': typeof AuthenticatedLayoutMeSecurityMfaSetupRoute
  '/_authenticated/_layout/me/security/mfa-sms-setup': typeof AuthenticatedLayoutMeSecurityMfaSmsSetupRoute
  '/_authenticated/_layout/me/security/mfa-totp-setup': typeof AuthenticatedLayoutMeSecurityMfaTotpSetupRoute
  '/_authenticated/_layout/platform/applications/$applicationId': typeof AuthenticatedLayoutPlatformApplicationsApplicationIdRoute
  '/_authenticated/_layout/platform/tenants/$tenantId': typeof AuthenticatedLayoutPlatformTenantsTenantIdRouteWithChildren
  '/_authenticated/_layout/tenant/roles/$roleId': typeof AuthenticatedLayoutTenantRolesRoleIdRoute
  '/_authenticated/_layout/tenant/users/new': typeof AuthenticatedLayoutTenantUsersNewRoute
  '/_authenticated/_layout/me/security/': typeof AuthenticatedLayoutMeSecurityIndexRoute
  '/_authenticated/_layout/platform/applications/': typeof AuthenticatedLayoutPlatformApplicationsIndexRoute
  '/_authenticated/_layout/platform/tenants/': typeof AuthenticatedLayoutPlatformTenantsIndexRoute
  '/_authenticated/_layout/tenant/roles/': typeof AuthenticatedLayoutTenantRolesIndexRoute
  '/_authenticated/_layout/tenant/users/': typeof AuthenticatedLayoutTenantUsersIndexRoute
  '/_authenticated/_layout/platform/tenants/$tenantId/branding': typeof AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute
  '/_authenticated/_layout/platform/tenants/$tenantId/integrations': typeof AuthenticatedLayoutPlatformTenantsTenantIdIntegrationsRoute
  '/_authenticated/_layout/platform/tenants/$tenantId/roles': typeof AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute
  '/_authenticated/_layout/platform/tenants/$tenantId/user-fields': typeof AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute
  '/_authenticated/_layout/platform/tenants/$tenantId/users': typeof AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute
  '/_authenticated/_layout/platform/tenants/$tenantId/': typeof AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute
  '/_authenticated/_layout/platform/tenants/$tenantId/levels/$level': typeof AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/activate'
    | '/forgot-password'
    | '/login'
    | '/self-register'
    | '/'
    | '/login/mfa-challenge'
    | '/login/mfa-email-setup'
    | '/login/mfa-setup'
    | '/login/mfa-totp-setup'
    | '/login/new-password'
    | '/login/'
    | '/platform'
    | '/me/profile'
    | '/platform/admins'
    | '/platform/audit'
    | '/platform/branding'
    | '/platform/roles'
    | '/platform/security'
    | '/platform/tenant-types'
    | '/tenant/audit'
    | '/tenant/branding'
    | '/tenant/groups'
    | '/tenant/security'
    | '/me/security/change-password'
    | '/me/security/mfa-email-setup'
    | '/me/security/mfa-preference'
    | '/me/security/mfa-setup'
    | '/me/security/mfa-sms-setup'
    | '/me/security/mfa-totp-setup'
    | '/platform/applications/$applicationId'
    | '/platform/tenants/$tenantId'
    | '/tenant/roles/$roleId'
    | '/tenant/users/new'
    | '/me/security/'
    | '/platform/applications/'
    | '/platform/tenants/'
    | '/tenant/roles/'
    | '/tenant/users/'
    | '/platform/tenants/$tenantId/branding'
    | '/platform/tenants/$tenantId/integrations'
    | '/platform/tenants/$tenantId/roles'
    | '/platform/tenants/$tenantId/user-fields'
    | '/platform/tenants/$tenantId/users'
    | '/platform/tenants/$tenantId/'
    | '/platform/tenants/$tenantId/levels/$level'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/activate'
    | '/forgot-password'
    | '/self-register'
    | '/login/mfa-challenge'
    | '/login/mfa-email-setup'
    | '/login/mfa-setup'
    | '/login/mfa-totp-setup'
    | '/login/new-password'
    | '/login'
    | '/platform'
    | '/'
    | '/me/profile'
    | '/platform/admins'
    | '/platform/audit'
    | '/platform/branding'
    | '/platform/roles'
    | '/platform/security'
    | '/platform/tenant-types'
    | '/tenant/audit'
    | '/tenant/branding'
    | '/tenant/groups'
    | '/tenant/security'
    | '/me/security/change-password'
    | '/me/security/mfa-email-setup'
    | '/me/security/mfa-preference'
    | '/me/security/mfa-setup'
    | '/me/security/mfa-sms-setup'
    | '/me/security/mfa-totp-setup'
    | '/platform/applications/$applicationId'
    | '/tenant/roles/$roleId'
    | '/tenant/users/new'
    | '/me/security'
    | '/platform/applications'
    | '/platform/tenants'
    | '/tenant/roles'
    | '/tenant/users'
    | '/platform/tenants/$tenantId/branding'
    | '/platform/tenants/$tenantId/integrations'
    | '/platform/tenants/$tenantId/roles'
    | '/platform/tenants/$tenantId/user-fields'
    | '/platform/tenants/$tenantId/users'
    | '/platform/tenants/$tenantId'
    | '/platform/tenants/$tenantId/levels/$level'
  id:
    | '__root__'
    | '/activate'
    | '/forgot-password'
    | '/login'
    | '/self-register'
    | '/_authenticated/_layout'
    | '/login/mfa-challenge'
    | '/login/mfa-email-setup'
    | '/login/mfa-setup'
    | '/login/mfa-totp-setup'
    | '/login/new-password'
    | '/login/'
    | '/_authenticated/_layout/platform'
    | '/_authenticated/_layout/'
    | '/_authenticated/_layout/me/profile'
    | '/_authenticated/_layout/platform/admins'
    | '/_authenticated/_layout/platform/audit'
    | '/_authenticated/_layout/platform/branding'
    | '/_authenticated/_layout/platform/roles'
    | '/_authenticated/_layout/platform/security'
    | '/_authenticated/_layout/platform/tenant-types'
    | '/_authenticated/_layout/tenant/audit'
    | '/_authenticated/_layout/tenant/branding'
    | '/_authenticated/_layout/tenant/groups'
    | '/_authenticated/_layout/tenant/security'
    | '/_authenticated/_layout/me/security/change-password'
    | '/_authenticated/_layout/me/security/mfa-email-setup'
    | '/_authenticated/_layout/me/security/mfa-preference'
    | '/_authenticated/_layout/me/security/mfa-setup'
    | '/_authenticated/_layout/me/security/mfa-sms-setup'
    | '/_authenticated/_layout/me/security/mfa-totp-setup'
    | '/_authenticated/_layout/platform/applications/$applicationId'
    | '/_authenticated/_layout/platform/tenants/$tenantId'
    | '/_authenticated/_layout/tenant/roles/$roleId'
    | '/_authenticated/_layout/tenant/users/new'
    | '/_authenticated/_layout/me/security/'
    | '/_authenticated/_layout/platform/applications/'
    | '/_authenticated/_layout/platform/tenants/'
    | '/_authenticated/_layout/tenant/roles/'
    | '/_authenticated/_layout/tenant/users/'
    | '/_authenticated/_layout/platform/tenants/$tenantId/branding'
    | '/_authenticated/_layout/platform/tenants/$tenantId/integrations'
    | '/_authenticated/_layout/platform/tenants/$tenantId/roles'
    | '/_authenticated/_layout/platform/tenants/$tenantId/user-fields'
    | '/_authenticated/_layout/platform/tenants/$tenantId/users'
    | '/_authenticated/_layout/platform/tenants/$tenantId/'
    | '/_authenticated/_layout/platform/tenants/$tenantId/levels/$level'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ActivateRoute: typeof ActivateRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRouteWithChildren
  SelfRegisterRoute: typeof SelfRegisterRoute
  AuthenticatedLayoutRoute: typeof AuthenticatedLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/self-register': {
      id: '/self-register'
      path: '/self-register'
      fullPath: '/self-register'
      preLoaderRoute: typeof SelfRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/new-password': {
      id: '/login/new-password'
      path: '/new-password'
      fullPath: '/login/new-password'
      preLoaderRoute: typeof LoginNewPasswordRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/mfa-totp-setup': {
      id: '/login/mfa-totp-setup'
      path: '/mfa-totp-setup'
      fullPath: '/login/mfa-totp-setup'
      preLoaderRoute: typeof LoginMfaTotpSetupRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/mfa-setup': {
      id: '/login/mfa-setup'
      path: '/mfa-setup'
      fullPath: '/login/mfa-setup'
      preLoaderRoute: typeof LoginMfaSetupRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/mfa-email-setup': {
      id: '/login/mfa-email-setup'
      path: '/mfa-email-setup'
      fullPath: '/login/mfa-email-setup'
      preLoaderRoute: typeof LoginMfaEmailSetupRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/mfa-challenge': {
      id: '/login/mfa-challenge'
      path: '/mfa-challenge'
      fullPath: '/login/mfa-challenge'
      preLoaderRoute: typeof LoginMfaChallengeRouteImport
      parentRoute: typeof LoginRoute
    }
    '/_authenticated/_layout': {
      id: '/_authenticated/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_layout/': {
      id: '/_authenticated/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/platform': {
      id: '/_authenticated/_layout/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/security': {
      id: '/_authenticated/_layout/tenant/security'
      path: '/tenant/security'
      fullPath: '/tenant/security'
      preLoaderRoute: typeof AuthenticatedLayoutTenantSecurityRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/groups': {
      id: '/_authenticated/_layout/tenant/groups'
      path: '/tenant/groups'
      fullPath: '/tenant/groups'
      preLoaderRoute: typeof AuthenticatedLayoutTenantGroupsRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/branding': {
      id: '/_authenticated/_layout/tenant/branding'
      path: '/tenant/branding'
      fullPath: '/tenant/branding'
      preLoaderRoute: typeof AuthenticatedLayoutTenantBrandingRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/audit': {
      id: '/_authenticated/_layout/tenant/audit'
      path: '/tenant/audit'
      fullPath: '/tenant/audit'
      preLoaderRoute: typeof AuthenticatedLayoutTenantAuditRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/platform/tenant-types': {
      id: '/_authenticated/_layout/platform/tenant-types'
      path: '/tenant-types'
      fullPath: '/platform/tenant-types'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantTypesRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/platform/security': {
      id: '/_authenticated/_layout/platform/security'
      path: '/security'
      fullPath: '/platform/security'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformSecurityRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/platform/roles': {
      id: '/_authenticated/_layout/platform/roles'
      path: '/roles'
      fullPath: '/platform/roles'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformRolesRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/platform/branding': {
      id: '/_authenticated/_layout/platform/branding'
      path: '/branding'
      fullPath: '/platform/branding'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformBrandingRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/platform/audit': {
      id: '/_authenticated/_layout/platform/audit'
      path: '/audit'
      fullPath: '/platform/audit'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformAuditRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/platform/admins': {
      id: '/_authenticated/_layout/platform/admins'
      path: '/admins'
      fullPath: '/platform/admins'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformAdminsRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/me/profile': {
      id: '/_authenticated/_layout/me/profile'
      path: '/me/profile'
      fullPath: '/me/profile'
      preLoaderRoute: typeof AuthenticatedLayoutMeProfileRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/users/': {
      id: '/_authenticated/_layout/tenant/users/'
      path: '/tenant/users'
      fullPath: '/tenant/users/'
      preLoaderRoute: typeof AuthenticatedLayoutTenantUsersIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/roles/': {
      id: '/_authenticated/_layout/tenant/roles/'
      path: '/tenant/roles'
      fullPath: '/tenant/roles/'
      preLoaderRoute: typeof AuthenticatedLayoutTenantRolesIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/platform/tenants/': {
      id: '/_authenticated/_layout/platform/tenants/'
      path: '/tenants'
      fullPath: '/platform/tenants/'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/platform/applications/': {
      id: '/_authenticated/_layout/platform/applications/'
      path: '/applications'
      fullPath: '/platform/applications/'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformApplicationsIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/me/security/': {
      id: '/_authenticated/_layout/me/security/'
      path: '/me/security'
      fullPath: '/me/security/'
      preLoaderRoute: typeof AuthenticatedLayoutMeSecurityIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/users/new': {
      id: '/_authenticated/_layout/tenant/users/new'
      path: '/tenant/users/new'
      fullPath: '/tenant/users/new'
      preLoaderRoute: typeof AuthenticatedLayoutTenantUsersNewRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/tenant/roles/$roleId': {
      id: '/_authenticated/_layout/tenant/roles/$roleId'
      path: '/tenant/roles/$roleId'
      fullPath: '/tenant/roles/$roleId'
      preLoaderRoute: typeof AuthenticatedLayoutTenantRolesRoleIdRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId'
      path: '/tenants/$tenantId'
      fullPath: '/platform/tenants/$tenantId'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/platform/applications/$applicationId': {
      id: '/_authenticated/_layout/platform/applications/$applicationId'
      path: '/applications/$applicationId'
      fullPath: '/platform/applications/$applicationId'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformApplicationsApplicationIdRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformRoute
    }
    '/_authenticated/_layout/me/security/mfa-totp-setup': {
      id: '/_authenticated/_layout/me/security/mfa-totp-setup'
      path: '/me/security/mfa-totp-setup'
      fullPath: '/me/security/mfa-totp-setup'
      preLoaderRoute: typeof AuthenticatedLayoutMeSecurityMfaTotpSetupRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/me/security/mfa-sms-setup': {
      id: '/_authenticated/_layout/me/security/mfa-sms-setup'
      path: '/me/security/mfa-sms-setup'
      fullPath: '/me/security/mfa-sms-setup'
      preLoaderRoute: typeof AuthenticatedLayoutMeSecurityMfaSmsSetupRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/me/security/mfa-setup': {
      id: '/_authenticated/_layout/me/security/mfa-setup'
      path: '/me/security/mfa-setup'
      fullPath: '/me/security/mfa-setup'
      preLoaderRoute: typeof AuthenticatedLayoutMeSecurityMfaSetupRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/me/security/mfa-preference': {
      id: '/_authenticated/_layout/me/security/mfa-preference'
      path: '/me/security/mfa-preference'
      fullPath: '/me/security/mfa-preference'
      preLoaderRoute: typeof AuthenticatedLayoutMeSecurityMfaPreferenceRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/me/security/mfa-email-setup': {
      id: '/_authenticated/_layout/me/security/mfa-email-setup'
      path: '/me/security/mfa-email-setup'
      fullPath: '/me/security/mfa-email-setup'
      preLoaderRoute: typeof AuthenticatedLayoutMeSecurityMfaEmailSetupRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/me/security/change-password': {
      id: '/_authenticated/_layout/me/security/change-password'
      path: '/me/security/change-password'
      fullPath: '/me/security/change-password'
      preLoaderRoute: typeof AuthenticatedLayoutMeSecurityChangePasswordRouteImport
      parentRoute: typeof AuthenticatedLayoutRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId/': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId/'
      path: '/'
      fullPath: '/platform/tenants/$tenantId/'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdIndexRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId/users': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId/users'
      path: '/users'
      fullPath: '/platform/tenants/$tenantId/users'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdUsersRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId/user-fields': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId/user-fields'
      path: '/user-fields'
      fullPath: '/platform/tenants/$tenantId/user-fields'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId/roles': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId/roles'
      path: '/roles'
      fullPath: '/platform/tenants/$tenantId/roles'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRolesRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId/integrations': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId/integrations'
      path: '/integrations'
      fullPath: '/platform/tenants/$tenantId/integrations'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdIntegrationsRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId/branding': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId/branding'
      path: '/branding'
      fullPath: '/platform/tenants/$tenantId/branding'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdBrandingRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRoute
    }
    '/_authenticated/_layout/platform/tenants/$tenantId/levels/$level': {
      id: '/_authenticated/_layout/platform/tenants/$tenantId/levels/$level'
      path: '/levels/$level'
      fullPath: '/platform/tenants/$tenantId/levels/$level'
      preLoaderRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRouteImport
      parentRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRoute
    }
  }
}

interface LoginRouteChildren {
  LoginMfaChallengeRoute: typeof LoginMfaChallengeRoute
  LoginMfaEmailSetupRoute: typeof LoginMfaEmailSetupRoute
  LoginMfaSetupRoute: typeof LoginMfaSetupRoute
  LoginMfaTotpSetupRoute: typeof LoginMfaTotpSetupRoute
  LoginNewPasswordRoute: typeof LoginNewPasswordRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginMfaChallengeRoute: LoginMfaChallengeRoute,
  LoginMfaEmailSetupRoute: LoginMfaEmailSetupRoute,
  LoginMfaSetupRoute: LoginMfaSetupRoute,
  LoginMfaTotpSetupRoute: LoginMfaTotpSetupRoute,
  LoginNewPasswordRoute: LoginNewPasswordRoute,
  LoginIndexRoute: LoginIndexRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

interface AuthenticatedLayoutPlatformTenantsTenantIdRouteChildren {
  AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute
  AuthenticatedLayoutPlatformTenantsTenantIdIntegrationsRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdIntegrationsRoute
  AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute
  AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute
  AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute
  AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute
  AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute
}

const AuthenticatedLayoutPlatformTenantsTenantIdRouteChildren: AuthenticatedLayoutPlatformTenantsTenantIdRouteChildren =
  {
    AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdBrandingRoute,
    AuthenticatedLayoutPlatformTenantsTenantIdIntegrationsRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdIntegrationsRoute,
    AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdRolesRoute,
    AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdUserFieldsRoute,
    AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdUsersRoute,
    AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdIndexRoute,
    AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdLevelsLevelRoute,
  }

const AuthenticatedLayoutPlatformTenantsTenantIdRouteWithChildren =
  AuthenticatedLayoutPlatformTenantsTenantIdRoute._addFileChildren(
    AuthenticatedLayoutPlatformTenantsTenantIdRouteChildren,
  )

interface AuthenticatedLayoutPlatformRouteChildren {
  AuthenticatedLayoutPlatformAdminsRoute: typeof AuthenticatedLayoutPlatformAdminsRoute
  AuthenticatedLayoutPlatformAuditRoute: typeof AuthenticatedLayoutPlatformAuditRoute
  AuthenticatedLayoutPlatformBrandingRoute: typeof AuthenticatedLayoutPlatformBrandingRoute
  AuthenticatedLayoutPlatformRolesRoute: typeof AuthenticatedLayoutPlatformRolesRoute
  AuthenticatedLayoutPlatformSecurityRoute: typeof AuthenticatedLayoutPlatformSecurityRoute
  AuthenticatedLayoutPlatformTenantTypesRoute: typeof AuthenticatedLayoutPlatformTenantTypesRoute
  AuthenticatedLayoutPlatformApplicationsApplicationIdRoute: typeof AuthenticatedLayoutPlatformApplicationsApplicationIdRoute
  AuthenticatedLayoutPlatformTenantsTenantIdRoute: typeof AuthenticatedLayoutPlatformTenantsTenantIdRouteWithChildren
  AuthenticatedLayoutPlatformApplicationsIndexRoute: typeof AuthenticatedLayoutPlatformApplicationsIndexRoute
  AuthenticatedLayoutPlatformTenantsIndexRoute: typeof AuthenticatedLayoutPlatformTenantsIndexRoute
}

const AuthenticatedLayoutPlatformRouteChildren: AuthenticatedLayoutPlatformRouteChildren =
  {
    AuthenticatedLayoutPlatformAdminsRoute:
      AuthenticatedLayoutPlatformAdminsRoute,
    AuthenticatedLayoutPlatformAuditRoute:
      AuthenticatedLayoutPlatformAuditRoute,
    AuthenticatedLayoutPlatformBrandingRoute:
      AuthenticatedLayoutPlatformBrandingRoute,
    AuthenticatedLayoutPlatformRolesRoute:
      AuthenticatedLayoutPlatformRolesRoute,
    AuthenticatedLayoutPlatformSecurityRoute:
      AuthenticatedLayoutPlatformSecurityRoute,
    AuthenticatedLayoutPlatformTenantTypesRoute:
      AuthenticatedLayoutPlatformTenantTypesRoute,
    AuthenticatedLayoutPlatformApplicationsApplicationIdRoute:
      AuthenticatedLayoutPlatformApplicationsApplicationIdRoute,
    AuthenticatedLayoutPlatformTenantsTenantIdRoute:
      AuthenticatedLayoutPlatformTenantsTenantIdRouteWithChildren,
    AuthenticatedLayoutPlatformApplicationsIndexRoute:
      AuthenticatedLayoutPlatformApplicationsIndexRoute,
    AuthenticatedLayoutPlatformTenantsIndexRoute:
      AuthenticatedLayoutPlatformTenantsIndexRoute,
  }

const AuthenticatedLayoutPlatformRouteWithChildren =
  AuthenticatedLayoutPlatformRoute._addFileChildren(
    AuthenticatedLayoutPlatformRouteChildren,
  )

interface AuthenticatedLayoutRouteChildren {
  AuthenticatedLayoutPlatformRoute: typeof AuthenticatedLayoutPlatformRouteWithChildren
  AuthenticatedLayoutIndexRoute: typeof AuthenticatedLayoutIndexRoute
  AuthenticatedLayoutMeProfileRoute: typeof AuthenticatedLayoutMeProfileRoute
  AuthenticatedLayoutTenantAuditRoute: typeof AuthenticatedLayoutTenantAuditRoute
  AuthenticatedLayoutTenantBrandingRoute: typeof AuthenticatedLayoutTenantBrandingRoute
  AuthenticatedLayoutTenantGroupsRoute: typeof AuthenticatedLayoutTenantGroupsRoute
  AuthenticatedLayoutTenantSecurityRoute: typeof AuthenticatedLayoutTenantSecurityRoute
  AuthenticatedLayoutMeSecurityChangePasswordRoute: typeof AuthenticatedLayoutMeSecurityChangePasswordRoute
  AuthenticatedLayoutMeSecurityMfaEmailSetupRoute: typeof AuthenticatedLayoutMeSecurityMfaEmailSetupRoute
  AuthenticatedLayoutMeSecurityMfaPreferenceRoute: typeof AuthenticatedLayoutMeSecurityMfaPreferenceRoute
  AuthenticatedLayoutMeSecurityMfaSetupRoute: typeof AuthenticatedLayoutMeSecurityMfaSetupRoute
  AuthenticatedLayoutMeSecurityMfaSmsSetupRoute: typeof AuthenticatedLayoutMeSecurityMfaSmsSetupRoute
  AuthenticatedLayoutMeSecurityMfaTotpSetupRoute: typeof AuthenticatedLayoutMeSecurityMfaTotpSetupRoute
  AuthenticatedLayoutTenantRolesRoleIdRoute: typeof AuthenticatedLayoutTenantRolesRoleIdRoute
  AuthenticatedLayoutTenantUsersNewRoute: typeof AuthenticatedLayoutTenantUsersNewRoute
  AuthenticatedLayoutMeSecurityIndexRoute: typeof AuthenticatedLayoutMeSecurityIndexRoute
  AuthenticatedLayoutTenantRolesIndexRoute: typeof AuthenticatedLayoutTenantRolesIndexRoute
  AuthenticatedLayoutTenantUsersIndexRoute: typeof AuthenticatedLayoutTenantUsersIndexRoute
}

const AuthenticatedLayoutRouteChildren: AuthenticatedLayoutRouteChildren = {
  AuthenticatedLayoutPlatformRoute:
    AuthenticatedLayoutPlatformRouteWithChildren,
  AuthenticatedLayoutIndexRoute: AuthenticatedLayoutIndexRoute,
  AuthenticatedLayoutMeProfileRoute: AuthenticatedLayoutMeProfileRoute,
  AuthenticatedLayoutTenantAuditRoute: AuthenticatedLayoutTenantAuditRoute,
  AuthenticatedLayoutTenantBrandingRoute:
    AuthenticatedLayoutTenantBrandingRoute,
  AuthenticatedLayoutTenantGroupsRoute: AuthenticatedLayoutTenantGroupsRoute,
  AuthenticatedLayoutTenantSecurityRoute:
    AuthenticatedLayoutTenantSecurityRoute,
  AuthenticatedLayoutMeSecurityChangePasswordRoute:
    AuthenticatedLayoutMeSecurityChangePasswordRoute,
  AuthenticatedLayoutMeSecurityMfaEmailSetupRoute:
    AuthenticatedLayoutMeSecurityMfaEmailSetupRoute,
  AuthenticatedLayoutMeSecurityMfaPreferenceRoute:
    AuthenticatedLayoutMeSecurityMfaPreferenceRoute,
  AuthenticatedLayoutMeSecurityMfaSetupRoute:
    AuthenticatedLayoutMeSecurityMfaSetupRoute,
  AuthenticatedLayoutMeSecurityMfaSmsSetupRoute:
    AuthenticatedLayoutMeSecurityMfaSmsSetupRoute,
  AuthenticatedLayoutMeSecurityMfaTotpSetupRoute:
    AuthenticatedLayoutMeSecurityMfaTotpSetupRoute,
  AuthenticatedLayoutTenantRolesRoleIdRoute:
    AuthenticatedLayoutTenantRolesRoleIdRoute,
  AuthenticatedLayoutTenantUsersNewRoute:
    AuthenticatedLayoutTenantUsersNewRoute,
  AuthenticatedLayoutMeSecurityIndexRoute:
    AuthenticatedLayoutMeSecurityIndexRoute,
  AuthenticatedLayoutTenantRolesIndexRoute:
    AuthenticatedLayoutTenantRolesIndexRoute,
  AuthenticatedLayoutTenantUsersIndexRoute:
    AuthenticatedLayoutTenantUsersIndexRoute,
}

const AuthenticatedLayoutRouteWithChildren =
  AuthenticatedLayoutRoute._addFileChildren(AuthenticatedLayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ActivateRoute: ActivateRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRouteWithChildren,
  SelfRegisterRoute: SelfRegisterRoute,
  AuthenticatedLayoutRoute: AuthenticatedLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
